module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Vjoin"
  }, [(_vm.popUp) ? _c('div', {
    staticClass: "black-bg"
  }, [_c('div', [_c('h5', [_vm._v(_vm._s(_vm.popUp) + " "), _c('div', {
    on: {
      "click": function($event) {
        return _vm.popUpWindow(false)
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), (_vm.popUp == '登录') ? _c('div', {
    on: {
      "keyup": function($event) {
        return _vm.toLogin($event)
      }
    }
  }, [_c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "username"
  }, [_c('i', {
    staticClass: "icon icon-log"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "userinput",
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "blur": function($event) {
        return _vm.checkLogUser(_vm.username, 'userError')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.userError) ? _c('p', [_c('i', {
    staticClass: "icon icon-exclamation"
  }), _vm._v("5-20个小写英文字母或数字组成")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "password"
  }, [_c('i', {
    staticClass: "icon icon-password"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "userinput",
    attrs: {
      "type": "password",
      "autocomplete": "off",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "blur": function($event) {
        return _vm.checkPassword(_vm.password, 'passwordError')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.passwordError) ? _c('p', [_c('i', {
    staticClass: "icon icon-exclamation"
  }), _vm._v("6-20个数字字母混合，不含空格键")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "orther"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cookieUser),
      expression: "cookieUser"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.cookieUser) ? _vm._i(_vm.cookieUser, null) > -1 : (_vm.cookieUser)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.cookieUser,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.cookieUser = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.cookieUser = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.cookieUser = $$c
        }
      }
    }
  }), _vm._v("记住用户名\n          "), _c('a', {
    staticClass: "hovera",
    on: {
      "click": _vm.retrievePassword
    }
  }, [_vm._v("忘记密码？")])]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.login
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('p', {
    staticClass: "register"
  }, [_vm._v("没有账号？请"), _c('a', {
    on: {
      "click": function($event) {
        return _vm.popUpWindow('快速注册')
      }
    }
  }, [_vm._v("注册")])])]) : _vm._e(), _vm._v(" "), (_vm.popUp == '快速注册') ? _c('div', [(_vm.register == 1) ? _c('div', {
    staticClass: "register-content",
    on: {
      "keyup": function($event) {
        return _vm.toTraffic($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registers.traffic.username),
      expression: "registers.traffic.username"
    }],
    attrs: {
      "type": "text",
      "placeholder": "账号"
    },
    domProps: {
      "value": (_vm.registers.traffic.username)
    },
    on: {
      "blur": function($event) {
        return _vm.checkUser(_vm.registers.traffic.username, 'registers', 'traffic', 'userError')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registers.traffic, "username", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error",
    class: {
      istrue: !_vm.registers.traffic.userError
    }
  }, [(_vm.registers.traffic.userError) ? _c('i', {
    staticClass: "icon icon-exclamation"
  }) : _vm._e(), _vm._v("5-20位字母和数字混合")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registers.traffic.password),
      expression: "registers.traffic.password"
    }],
    attrs: {
      "type": "password",
      "autocomplete": "off",
      "placeholder": "密码"
    },
    domProps: {
      "value": (_vm.registers.traffic.password)
    },
    on: {
      "blur": function($event) {
        return _vm.checkPassword(_vm.registers.traffic.password, 'registers', 'traffic', 'passwordError')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registers.traffic, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error",
    class: {
      istrue: !_vm.registers.traffic.passwordError
    }
  }, [(_vm.registers.traffic.passwordError) ? _c('i', {
    staticClass: "icon icon-exclamation"
  }) : _vm._e(), _vm._v("6-20个数字字母混合，不含空格键")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registers.traffic.passwordSure),
      expression: "registers.traffic.passwordSure"
    }],
    attrs: {
      "type": "password",
      "autocomplete": "off",
      "placeholder": "确认密码"
    },
    domProps: {
      "value": (_vm.registers.traffic.passwordSure)
    },
    on: {
      "blur": function($event) {
        return _vm.checkPasswordSure(_vm.registers.traffic.passwordSure, _vm.registers.traffic.password)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registers.traffic, "passwordSure", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error",
    class: {
      istrue: !_vm.registers.traffic.passwordSureError
    }
  }, [(_vm.registers.traffic.passwordSureError) ? _c('i', {
    staticClass: "icon icon-exclamation"
  }) : _vm._e(), _vm._v("两次输入的密码不一致")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registers.traffic.name),
      expression: "registers.traffic.name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "真实姓名"
    },
    domProps: {
      "value": (_vm.registers.traffic.name)
    },
    on: {
      "blur": function($event) {
        return _vm.checkName(_vm.registers.traffic.name, 'registers', 'traffic', 'nameError')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registers.traffic, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error",
    class: {
      istrue: !_vm.registers.traffic.nameError
    }
  }, [(_vm.registers.traffic.nameError) ? _c('i', {
    staticClass: "icon icon-exclamation"
  }) : _vm._e(), _vm._v("请输入您的姓名，2至4个汉字，例如：张三")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registers.traffic.idcard),
      expression: "registers.traffic.idcard"
    }],
    attrs: {
      "type": "text",
      "placeholder": "身份证号码"
    },
    domProps: {
      "value": (_vm.registers.traffic.idcard)
    },
    on: {
      "blur": function($event) {
        return _vm.checkIdcard(_vm.registers.traffic.idcard, 'registers', 'traffic', 'idcardError')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registers.traffic, "idcard", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error",
    class: {
      istrue: !_vm.registers.traffic.idcardError
    }
  }, [(_vm.registers.traffic.idcardError) ? _c('i', {
    staticClass: "icon icon-exclamation"
  }) : _vm._e(), _vm._v("请准确填写身份证号码")]), _vm._v(" "), _c('div', {
    staticClass: "verification"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registers.traffic.verify),
      expression: "registers.traffic.verify"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.registers.traffic.verify)
    },
    on: {
      "blur": function($event) {
        return _vm.checkVerify(_vm.registers.traffic.verify, 'registers', 'traffic', 'verifyError')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registers.traffic, "verify", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.registers.imgSrc,
      "alt": ""
    },
    on: {
      "click": _vm.changeImg
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "icon icon-re",
    on: {
      "click": _vm.changeImg
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "error",
    class: {
      istrue: !_vm.registers.traffic.verifyError
    }
  }, [(_vm.registers.traffic.verifyError) ? _c('i', {
    staticClass: "icon icon-exclamation"
  }) : _vm._e(), _vm._v("请输入验证码")]), _vm._v(" "), _c('p', {
    staticClass: "agreement"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registers.traffic.agree),
      expression: "registers.traffic.agree"
    }],
    staticClass: "check",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.registers.traffic.agree) ? _vm._i(_vm.registers.traffic.agree, null) > -1 : (_vm.registers.traffic.agree)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.registers.traffic.agree,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.registers.traffic, "agree", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.registers.traffic, "agree", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.registers.traffic, "agree", $$c)
        }
      }
    }
  }), _c('a', {
    on: {
      "click": function($event) {
        return _vm.onAgreementChange('魔力通行证注册协议')
      }
    }
  }, [_vm._v("阅读并同意魔力通行证注册协议")])]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.registersTraffic
    }
  }, [_vm._v("快速注册")]), _vm._v(" "), _c('p', {
    staticClass: "register"
  }, [_vm._v("已注册？请"), _c('a', {
    on: {
      "click": function($event) {
        return _vm.popUpWindow('登录')
      }
    }
  }, [_vm._v("登录")])])]) : _vm._e(), _vm._v(" "), (_vm.register == 2) ? _c('div', {
    staticClass: "register-content",
    on: {
      "keyup": function($event) {
        return _vm.toPho($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registers.pho.phoNum),
      expression: "registers.pho.phoNum"
    }],
    attrs: {
      "type": "text",
      "placeholder": "手机号码"
    },
    domProps: {
      "value": (_vm.registers.pho.phoNum)
    },
    on: {
      "blur": function($event) {
        return _vm.checkPhoNum(_vm.registers.pho.phoNum, 'registers', 'pho', 'phoNumError')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registers.pho, "phoNum", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error",
    class: {
      istrue: !_vm.registers.pho.phoNumError
    }
  }, [(_vm.registers.pho.phoNumError) ? _c('i', {
    staticClass: "icon icon-exclamation"
  }) : _vm._e(), _vm._v("请输入正确的手机号")]), _vm._v(" "), _c('div', {
    staticClass: "verification"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registers.pho.verify),
      expression: "registers.pho.verify"
    }],
    attrs: {
      "type": "text",
      "placeholder": "验证码"
    },
    domProps: {
      "value": (_vm.registers.pho.verify)
    },
    on: {
      "blur": function($event) {
        return _vm.checkVerify(_vm.registers.pho.verify, 'registers', 'pho', 'verifyError')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registers.pho, "verify", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.registers.imgSrc,
      "alt": ""
    },
    on: {
      "click": _vm.changeImg
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "icon icon-re",
    on: {
      "click": _vm.changeImg
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "error",
    class: {
      istrue: !_vm.registers.pho.verifyError
    }
  }, [(_vm.registers.pho.verifyError) ? _c('i', {
    staticClass: "icon icon-exclamation"
  }) : _vm._e(), _vm._v("请输入验证码")]), _vm._v(" "), _c('div', {
    staticClass: "getMessage"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registers.pho.phoverify),
      expression: "registers.pho.phoverify"
    }],
    attrs: {
      "type": "text",
      "placeholder": "手机验证码"
    },
    domProps: {
      "value": (_vm.registers.pho.phoverify)
    },
    on: {
      "blur": _vm.phoverifyblur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registers.pho, "phoverify", $event.target.value)
      }
    }
  }), _vm._v(" "), (!_vm.phoTime) ? _c('div', {
    staticClass: "getMessageBtb",
    on: {
      "click": _vm.getMessage
    }
  }, [_vm._v("获取验证码")]) : _vm._e(), _vm._v(" "), (_vm.phoTime) ? _c('div', {
    staticClass: "getMessageBtbNo"
  }, [_vm._v("请稍等" + _vm._s(_vm.phoTime) + "秒")]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "error",
    class: {
      istrue: _vm.registers.pho.phoverify || (!_vm.registers.pho.check)
    }
  }, [((!_vm.registers.pho.phoverify) && (_vm.registers.pho.check)) ? _c('i', {
    staticClass: "icon icon-exclamation"
  }) : _vm._e(), _vm._v("请输短信入验证码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registers.pho.password),
      expression: "registers.pho.password"
    }],
    attrs: {
      "type": "password",
      "autocomplete": "off",
      "placeholder": "密码"
    },
    domProps: {
      "value": (_vm.registers.pho.password)
    },
    on: {
      "blur": function($event) {
        return _vm.checkPassword(_vm.registers.pho.password, 'registers', 'pho', 'passwordError')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registers.pho, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error",
    class: {
      istrue: !_vm.registers.pho.passwordError
    }
  }, [(_vm.registers.pho.passwordError) ? _c('i', {
    staticClass: "icon icon-exclamation"
  }) : _vm._e(), _vm._v("6-20个数字字母混合，不含空格键")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registers.pho.passwordSure),
      expression: "registers.pho.passwordSure"
    }],
    attrs: {
      "type": "password",
      "autocomplete": "off",
      "placeholder": "确认密码"
    },
    domProps: {
      "value": (_vm.registers.pho.passwordSure)
    },
    on: {
      "blur": function($event) {
        return _vm.checkPasswordSure1(_vm.registers.pho.passwordSure, _vm.registers.pho.password)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registers.pho, "passwordSure", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error",
    class: {
      istrue: !_vm.registers.pho.passwordSureError
    }
  }, [(_vm.registers.pho.passwordSureError) ? _c('i', {
    staticClass: "icon icon-exclamation"
  }) : _vm._e(), _vm._v("两次输入的密码不一致")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registers.pho.name),
      expression: "registers.pho.name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "真实姓名"
    },
    domProps: {
      "value": (_vm.registers.pho.name)
    },
    on: {
      "blur": function($event) {
        return _vm.checkName(_vm.registers.pho.name, 'registers', 'pho', 'nameError')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registers.pho, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error",
    class: {
      istrue: !_vm.registers.pho.nameError
    }
  }, [(_vm.registers.pho.nameError) ? _c('i', {
    staticClass: "icon icon-exclamation"
  }) : _vm._e(), _vm._v("请输入您的姓名，2至4个汉字，例如：张三")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registers.pho.idcard),
      expression: "registers.pho.idcard"
    }],
    attrs: {
      "type": "text",
      "placeholder": "身份证号码"
    },
    domProps: {
      "value": (_vm.registers.pho.idcard)
    },
    on: {
      "blur": function($event) {
        return _vm.checkIdcard(_vm.registers.pho.idcard, 'registers', 'pho', 'idcardError')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registers.pho, "idcard", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error",
    class: {
      istrue: !_vm.registers.pho.idcardError
    }
  }, [(_vm.registers.pho.idcardError) ? _c('i', {
    staticClass: "icon icon-exclamation"
  }) : _vm._e(), _vm._v("请准确填写身份证号码")]), _vm._v(" "), _c('p', {
    staticClass: "agreement"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registers.pho.agree),
      expression: "registers.pho.agree"
    }],
    staticClass: "check",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.registers.pho.agree) ? _vm._i(_vm.registers.pho.agree, null) > -1 : (_vm.registers.pho.agree)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.registers.pho.agree,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.registers.pho, "agree", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.registers.pho, "agree", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.registers.pho, "agree", $$c)
        }
      }
    }
  }), _c('a', {
    on: {
      "click": function($event) {
        return _vm.onAgreementChange('魔力通行证注册协议')
      }
    }
  }, [_vm._v("阅读并同意魔力通行证注册协议")])]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.registersPho
    }
  }, [_vm._v("快速注册")]), _vm._v(" "), _c('p', {
    staticClass: "register"
  }, [_vm._v("已注册？请"), _c('a', {
    on: {
      "click": function($event) {
        return _vm.popUpWindow('登录')
      }
    }
  }, [_vm._v("登录")])])]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('Valert', {
    attrs: {
      "massage": _vm.massagenew
    },
    on: {
      "on-massage-change": _vm.onMassageChange
    }
  }), _vm._v(" "), _c('Vagreement', {
    attrs: {
      "agreement": _vm.agreementnew
    },
    on: {
      "on-agreement-change": _vm.onAgreementChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59a4da43","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/component/join.vue
// module id = 54
// module chunks = 70